<template>
  <div class="icon-block">
    <v-icon :size="iconSize" :color="iconColor">
      {{ icon }}
    </v-icon>

    <span class="icon-block-text">
      <slot></slot>
    </span>
  </div>
</template>

<script setup>
import styles from '@/components/styleVariables'
// import { defineProps } from 'vue'

defineProps({
  icon: {
    type: String,
    required: true,
  },
  iconColor: {
    type: String,
    required: false,
    default: styles.colors.black,
  },
  iconSize: {
    type: Number,
    required: false,
    default: 24,
  },
})
</script>

<style lang="scss" scoped>
.icon-block {
  display: flex;
  gap: 10px;
  align-items: center;
}

.icon-block-text {
  font-size: 16px;
  line-height: 19px;
  font-weight: 400;
}
</style>
